DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ProfileController extends DialogController
    constructor: (@state, @transitions, @modalInstance, ProfileData) ->
        super(@state, @transitions, @modalInstance)

        @scope.title = 'Profile:'
        @scope.profile =
            user_name: null
            phone: null
            email: null
            address:
                addr1: null
                addr2: null
                city: null
                zip: null
                state: null

        jsr = ProfileData.data

        if jsr.status.type is 'success'
            @scope.title = "Profile: #{jsr.data.user_name}"
            $.extend(@scope.profile, jsr.data)
